import { JsonPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'tmw-number-range',
  standalone: true,
  imports: [NgbDatepickerModule, FormsModule, JsonPipe],
  templateUrl: './number-range.component.html',
  styleUrl: './number-range.component.scss',
})
export class TmwNumberRangeComponent {
  @Output() numberFromChange = new EventEmitter();
  @Input() set numberFrom(dt: number | null | undefined) {
    this.fromNumber = dt ?? 0;
  }
  fromNumber?: number | null = 0;

  @Output() numberToChange = new EventEmitter();
  @Input() set numberTo(dt: number | null | undefined) {
    this.toNumber = dt;
  }
  toNumber?: number | null = Number.MAX_SAFE_INTEGER;

  onDateSelection(value: number) {
    if (!this.fromNumber && !this.toNumber) {
      this.fromNumber = value;
      this.numberFromChange.emit(this.fromNumber);
    } else if (this.fromNumber && !this.toNumber && value && value > this.fromNumber) {
      this.toNumber = value;
      this.numberToChange.emit(this.toNumber);
    } else {
      this.toNumber = null;
      this.numberToChange.emit(this.toNumber);
      this.fromNumber = value;
      this.numberFromChange.emit(this.fromNumber);
    }
  }
}
